class B2BOffer extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.productVariants = JSON.parse(this.querySelector("[data-dynamic-variants]").textContent);
    this.cart = document.querySelector("cart-drawer");

    this.querySelectorAll('[id^="B2BProductForm-"]').forEach(form => {
      form.addEventListener("submit", (e) => {
        this.onFormSubmit(e, form);
      })
    });

    this.querySelector('[id^="B2BProductOptions-"]')?.addEventListener("click", (e) => {
      const card = e.target.closest('.b2b-offer__pack-card');
      if (!card) return;
      const input = card.querySelector('input[type="radio"]');
      if (!input) return;
      input.checked = true;

      this.querySelectorAll(".b2b-offer__subscription-form").forEach(form => {
        form.classList.toggle("active", form.dataset.variant == input.dataset.variant);
      });
    });

    this.initRadioCards();
    this.initOnetimePurchase();
    this.initGallery();
    this.initClickListeners();
    this.initPackGrid();
  }

  initPackGrid() {
    // Size the "Choose your package" grid to the number of variant cards
    // actually rendered (1 variant = full width, 2 = halves, 3 = thirds…).
    // Liquid sets --pack-count inline; this is a fallback when it's absent.
    this.querySelectorAll('.b2b-offer__pack-cards').forEach(grid => {
      if (!grid.style.getPropertyValue('--pack-count')) {
        const count = grid.querySelectorAll('.b2b-offer__pack-card').length;
        if (count) grid.style.setProperty('--pack-count', count);
      }
    });
  }

  initOnetimePurchase() {
    const onetimeForm = this.querySelector('[id^="B2BProductFormOnetime-"]');
    if (!onetimeForm) return;

    const qtyInput = onetimeForm.querySelector('[name="quantity"]');
    const unitPrice = parseInt(onetimeForm.dataset.unitPrice);
    const maxQty = parseInt(qtyInput.max) || 10;

    const updateOnetimePrices = () => {
      const qty = Math.min(Math.max(parseInt(qtyInput.value) || 1, 1), maxQty);
      qtyInput.value = qty;
      const total = unitPrice * qty;
      const formatted = this.formatMoney(total);
      const ctaEl = onetimeForm.querySelector('[data-onetime-cta-price]');
      if (ctaEl) ctaEl.textContent = formatted;
    };

    onetimeForm.querySelector('[data-action="qty-minus"]')?.addEventListener('click', () => {
      const current = parseInt(qtyInput.value) || 1;
      if (current > 1) {
        qtyInput.value = current - 1;
        updateOnetimePrices();
      }
    });

    onetimeForm.querySelector('[data-action="qty-plus"]')?.addEventListener('click', () => {
      const current = parseInt(qtyInput.value) || 1;
      if (current < maxQty) {
        qtyInput.value = current + 1;
        updateOnetimePrices();
      }
    });

    qtyInput.addEventListener('change', updateOnetimePrices);

    onetimeForm.addEventListener('submit', (e) => {
      this.onFormSubmit(e, onetimeForm);
    });
  }

  initRadioCards() {
    this.querySelectorAll('.b2b-offer__subscription-form').forEach(form => {
      form.querySelectorAll('.b2b-offer__radio-card input[name="selling_plan"]').forEach(input => {
        input.addEventListener('change', () => {
          this.updateSummary(form);
        });
      });
    });
  }

  updateSummary(form) {
    const checkedInput = form.querySelector('[name="selling_plan"]:checked');
    if (!checkedInput) return;

    const total = checkedInput.dataset.total;
    const formattedTotal = this.formatMoney(parseInt(total));

    const summaryTotal = form.querySelector('[data-summary-total]');
    const ctaPrice = form.querySelector('[data-cta-price]');

    if (summaryTotal) summaryTotal.textContent = formattedTotal;
    if (ctaPrice) ctaPrice.textContent = formattedTotal;

    // Profit assumes a retail range of $99–$120 per unit (9900–12000 cents).
    // Subscribe profits are billed monthly; annual forecast = monthly × 12.
    // One-time purchases get a single profit range with no annual forecast.
    const isSubscribe = checkedInput.value !== '';
    const units = parseInt(form.dataset.units);
    const unitCost = parseInt(isSubscribe ? form.dataset.subUnitCost : form.dataset.onetimeUnitCost);
    const retailLow = 9900;
    const retailHigh = 12000;
    const profitLow = units * (retailLow - unitCost);
    const profitHigh = units * (retailHigh - unitCost);
    const profitRange = this.formatMoney(profitLow) + ' – ' + this.formatMoney(profitHigh);

    const revenueEl = form.querySelector('[data-summary-revenue]');
    if (revenueEl) {
      const suffix = isSubscribe ? ' / month' : '';
      revenueEl.textContent = 'Est. Profit @ $99–$120 Retail: ' + profitRange + suffix;
    }

    const annualEl = form.querySelector('[data-summary-annual]');
    if (annualEl) {
      if (isSubscribe) {
        const annualLow = profitLow * 12;
        const annualHigh = profitHigh * 12;
        annualEl.textContent = 'Annual Profit Forecast: ' + this.formatMoney(annualLow) + ' – ' + this.formatMoney(annualHigh) + ' / year';
        annualEl.hidden = false;
      } else {
        annualEl.hidden = true;
      }
    }
  }

  formatMoney(cents) {
    // Round to the nearest whole dollar and display with no cents, e.g. $1,201.
    const dollars = Math.round(cents / 100);
    return '$' + dollars.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  onFormSubmit(event = false, form) {
    if (event) event.preventDefault();

    if (this.isLoading) return;

    const sellingPlanInput = form.querySelector("[name='selling_plan']:checked");
    const cartData = {
      items: [
        {
          id: parseInt(form.querySelector("[name='id']").value),
          quantity: parseInt(form.querySelector("[name='quantity']").value),
        }
      ]
    };

    if (sellingPlanInput && sellingPlanInput.value) {
      cartData.items[0].selling_plan = parseInt(sellingPlanInput.value);
    }

    if (this.cart) {
      cartData['sections'] = this.cart.getSectionsToRender().map((section) => section.id)
      cartData['sections_url'] = window.location.pathname
    }

    this.addToCart(cartData);
  }

  addToCart(data) {
    if (!data) return;

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        const error = new Error(response.description);
        throw error;
      } else {
        this.toggleLoading();

        if (this.cart) {
          this.cart.renderContents(response);
          this.cart.classList.remove("is-empty");
          this.cart.open();
        }
      }
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading(true));
  }

  initGallery() {
    this.gallery = this.querySelector('[id^="B2BProductGallery-"]');
    this.navGallery = this.querySelector('[id^="B2BProductGalleryNav-"]');

    this.gallerySlide = 1;

    this.gallery.addEventListener('scroll', () => {
      const items = this.gallery.querySelectorAll('li');
      const scrollLeft = this.gallery.scrollLeft;
      const blockWidth = items[0]?.offsetWidth ?? 0;
      const gap = 12;

      this.gallerySlide = Math.round(scrollLeft / (blockWidth + gap)) + 1;

      items.forEach((item, index) => {
        if (index == (this.gallerySlide - 1)) {
          item.querySelector("video")?.play();
        } else {
          item.querySelector("video")?.pause();
        }
      })

      this.navGallery.querySelectorAll("li").forEach(slide => {
        slide.classList.toggle("active", slide.dataset.slide == this.gallerySlide);
      })
    });
  }

  initClickListeners() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "prev-slide":
            if (this.gallerySlide > 1) {
              this.scrollToSlide(this.gallery, this.gallerySlide - 1);
            }
            break;
          case "change-slide":
            this.scrollToSlide(this.gallery, parseInt(e.target.dataset.slide));
            break;
          case "next-slide":
            if (this.gallerySlide < this.gallery.querySelectorAll("li").length) {
              this.scrollToSlide(this.gallery, this.gallerySlide + 1);
            }
            break;
        }
      }
    })
  }

  scrollToSlide(slider, index) {
    if (!slider) return;

    slider.scrollTo({
      left: slider.querySelector(`li:nth-child(${index})`).offsetLeft,
      behavior: 'smooth'
    });
  }

  showError(error) {
    console.error(error);

    if (!this.querySelector("[product-notification]")) return;

    const messageBlock = this.querySelector("[product-notification]");

    messageBlock.innerText = error.message;
    setTimeout(() => {messageBlock.innerText = ''}, 5000);
    messageBlock.scrollIntoView({behavior: "smooth",block:"center"});
  }

  toggleLoading(turnOff = false) {
    this.isLoading = !this.isLoading;
    if (turnOff) this.isLoading = false;
    this.classList.toggle("loading", this.isLoading);
  }
}

customElements.define("b2b-offer", B2BOffer);